import { Inject, Injectable } from '@angular/core';
import {
  DataRequirements,
  DataRequirementsInjectionToken,
} from '../data.requirements';
import { ResourceDetailsMapper } from '../mappers/resource-details.mapper';

@Injectable({
  providedIn: 'root',
})
export class PostUrlUseCase {
  constructor(
    @Inject(DataRequirementsInjectionToken) private data: DataRequirements
  ) {}

  run(aerUrl) {
    return this.data.postUrl(aerUrl);
  }
}
